// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'

const iconStyle = {
  display: 'inline-block',
  height: 'auto',
  maxWidth: '18px',
  maxHeight: '18px',
}

const bl = {
  borderLeft: '1px solid',
  marginLeft: '.5em',
  paddingLeft: '.5em',
}

const Heading = ({ heading, iconPath, idRoot }) => (
  <h4 className={'uppercase white-space-nowrap text-overflow-ellipsis overflow-hidden'}>
    <img
      alt={`${heading} icon`}
      id={`${idRoot}-icon`}
      src={iconPath}
      style={iconStyle} />
    <span
      className={'white-space-nowrap text-overflow-ellipsis overflow-hidden'}
      id={`${idRoot}-heading`}
      style={bl}
      title={heading}>
      {heading}
    </span>
  </h4>
)

Heading.propTypes = {
  heading: string.isRequired,
  iconPath: string.isRequired,
  idRoot: string.isRequired,
}

export default Heading
